import React from 'react';
import cn from 'classnames';
import { Form, Input as InputAntd } from 'antd';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms/Typography';
import { ReactComponent as Clear } from 'dist/icons/clear.svg';
import { ReactComponent as Search } from 'dist/icons/search.svg';
import { useDebounceEffect } from 'helpers/useDebounceEffect';
import type { InputProps } from './types';
import './style.scss';

export const Input: React.FC<InputProps> = ({
  className,
  type = 'text',
  required,
  onDebounceChange,
  itemProps,
  delay,
  label,
  error,
  maxLength,
  onChange,
  optional,
  ...props
}) => {
  const onDebounce = useDebounceEffect(onDebounceChange, delay) as (e: React.ChangeEvent<HTMLInputElement>) => void;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    onDebounce?.(e);
  };
  return (
    <div className={cn('input-default-wrapper', className, { error })}>
      {label !== undefined && (
        <Typography.Label weight={TYPOGRAPHY_WEIGHT.BOLD}>
          {label}
          {!!required && <span> *</span>}
          {optional && <span className="optional"> (optional)</span>}
        </Typography.Label>
      )}
      <Form.Item {...itemProps}>
        <InputAntd
          className="input-default"
          maxLength={maxLength ?? 255}
          onChange={handleChange}
          allowClear={type === 'search' ? { clearIcon: <Clear /> } : undefined}
          prefix={type === 'search' ? <Search /> : undefined}
          autoComplete="off"
          {...props}
        />
      </Form.Item>
      {!!error && <Typography.Caption className="input-default__error-message">{error}</Typography.Caption>}
    </div>
  );
};
